
<template>
  <!--动态详情-->
  <div class="advanced-form dynamic">
    <a-form :form="form">
      <div class="card">
        <div class="card-head">
          <h3>动态信息</h3>
        </div>
        <div class="card-body">
          <section class="dyna-hd">
            <div class="user">
              <div class="avatar">
                <img :src="dynamicDetail.avatar" alt="">
              </div>
              <div class="value">
                <p>
                  <span class="nick">{{dynamicDetail.nick_name}}</span>
                  <span>发布时间: {{dynamicDetail.create_time}}</span>
                </p>
                <p class="column">发布栏目: {{dynamicDetail.circle_category_name}}</p>
              </div>
            </div>
            <a-button @click="deleteCircle" type="primary" size="small" v-hasPermi="['neighbour:dynamic:remoDynamic']">删除此动态</a-button>
          </section>

          <div class="dyna-content">
            <p class="descrip">{{dynamicDetail.content}}</p>

            <div v-if="dynamicDetail.medias && dynamicDetail.medias.length" class="media-box">
              <a-divider></a-divider>
              <div class="img-box" v-for="(item, index) of dynamicDetail.medias" :key="index">
                <!--状态：1.疑似违规 2.正常 3.违规-->
                <div @click="banMedias(item)" v-if="item.can_delete" class="delete">
                  <a-icon type="close-circle" theme="filled" />
                </div>
                <span v-if="item.can_delete === 0" class="flag" >已屏蔽</span>

                <div @click="openModal(item)" class="mask"></div>
                <img :src="item.thumbnail_url" alt="">
                <!--<video  v-else :src="item.url" controls>-->
                  <!--对不起，您的浏览器不支持该格式！-->
                <!--</video>-->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>评论信息</h3>
        </div>
        <div class="card-body">
          <div v-for="(item, index) of commentList" :key="index" class="comment">
            <div class="comment-hd">
              <div class="user">
                <div class="avatar"><img :src="item.avatar" alt=""></div>

                <div class="value">
                  <p class="name">{{item.nick_name}}<span v-if="item.tag">({{item.tag}})</span></p>
                  <span class="other">第{{item.floor}}楼 <span>{{item.create_time}}</span></span>
                </div>
              </div>
              <a-button @click="deleteComment(item.comment_id, '评论')" type="primary" size="small" v-hasPermi="['neighbour:dynamic:remoComment']">删除此评论</a-button>
            </div>
            <div class="comment-content">
              <div>{{item.content}}</div>
              <p v-if="item.reply_count" class="num">{{item.reply_count}}条评论</p>

              <template v-for="(el, i) of item.childs">
              <div v-if="i < 3" :key="i" class="list">
                <div class="nick-box">
                  <span class="time">{{el.create_time}}</span>
                  <span class="nick">{{el.nick_name}}</span>回复<span class="nick">{{el.object_nick_name}}</span>:
                </div>
                <p class="feed">{{el.content}}</p>
                <a-button @click="deleteComment(el.comment_id, '回复')" type="primary" size="small" v-hasPermi="['neighbour:dynamic:remoReply']">删除</a-button>
              </div>
              </template>

              <span
                @click="showMore = true"
                class="more"
                v-if="item.childs && item.childs.length > 3 && !showMore"
              >
                查看更多回复>>
              </span>

              <template  v-for="(el, i) of item.childs">
              <div v-if="i > 2 && showMore" :key="i" class="list">
                <div class="nick-box">
                  <span class="time">{{el.create_time}}</span>
                  <span class="nick">{{el.nick_name}}</span>回复<span class="nick">{{el.object_nick_name}}</span>:
                </div>
                <p class="feed">{{el.content}}</p>
                <a-button @click="deleteComment(el.comment_id, '回复')" type="primary" size="small" v-hasPermi="['neighbour:dynamic:remoReply']">删除</a-button>
              </div>
              </template>
            </div>
          </div>

          <div v-if="paginationParam.total" :style="{textAlign: 'center'}">
            <a-pagination @change="pageChange" v-bind="paginationParam" />
          </div>
        </div>
      </div>
    </a-form>

    <!--图片或视频的弹窗-->
    <a-modal
      :bodyStyle="{padding: '10px'}"
      :visible="visible"
      @cancel="visible=false"
      v-bind="$store.state.modalDetailConfig"
      width="auto"
    >
      <div :style="{height: '600px', display: 'flex', justifyContent: 'center', alignItems: 'center'}">
        <img v-if="dynamicDetail.fileType === 1" :style="{height: '100%', border: '1px solid #e8e8e8'}" :src="modalData.url" alt="">
        <video v-else :style="{height: '100%', border: '1px solid #e8e8e8'}" :src="modalData.url" controls autoplay>
          对不起，您的浏览器不支持该格式！
        </video>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'dynamicDetail',
  data () {
    return {
      showMore: false,
      modalData: '',
      visible: false,
      routeQuery: '',
      dynamicDetail: {},
      commentList: [],
      paginationParam: {
        current: 1,
        pageSize: 5,
        total: 0,
        showQuickJumper: true,
        showTotal: total => {
          return `共 ${total} 条`;
        }
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    this.routeQuery = this.$route.query.id;
    this.getDetail();
    this.getComments();
  },
  methods: {
    /** 屏幕图片或视频 */
    banMedias (item) {
      this._delete({
        url: `/circle/circles/${this.routeQuery}/medias`,
        params: { media: item.id }
      }).then(({data}) => {
        this.$message.success('屏蔽成功');
        this.getDetail();
        this.getComments();
      });
    },
    /** 获取评论列表 */
    getComments (page, pagesize) {
      this._get({
        url: `/circle/circles/${this.routeQuery}/comments`,
        params: {
          page: page || this.paginationParam.current,
          pagesize: pagesize || this.paginationParam.pageSize
        }
      }).then(({data}) => {
        this.commentList = data.list;
        this.paginationParam.total = data.total;
      });
    },
    /** 分页修改事件 */
    pageChange (page, pagesize) {
      this.paginationParam.current = page;
      this.paginationParam.pageSize = pagesize;

      this.getComments(page, pagesize);
    },
    /** 打开弹窗 */
    openModal (item) {
      this.visible = true;
      this.modalData = item;
    },
    /** 删除动态 */
    deleteCircle () {
      this.$confirm({
        title: '你确定要删除此动态',
        centered: true,
        onOk: (close) => {
          this._delete({
            url: '/circle/circles',
            params: { circle_id: this.routeQuery }
          }).then(({data}) => {
            close();
            this.$message.success('删除成功');
            this.$router.go(-1);
          });
        }
      });
    },
    /** 删除评论或回复 */
    deleteComment (commentId, type) {
      this.$confirm({
        title: `你确定要删除此${type}`,
        centered: true,
        onOk: (close) => {
          this._delete({
            url: '/circle/circles/comments',
            params: { comment_id: commentId }
          }).then(({data}) => {
            close();
            this.$message.success('删除成功');
            this.getComments();
          });
        }
      });
    },
    /* 获取详情 */
    getDetail () {
      this._get({
        url: `/circle/circles/${this.routeQuery}`,
        params: {}
      }).then(({data}) => {
        this.dynamicDetail = {
          nick_name: data.nick_name,
          avatar: data.avatar,
          create_time: data.create_time,
          circle_category_name: data.circle_category_name,
          content: data.content,
          fileType: data.file_type, // 0: 无, 1: 图片，2：视频
          medias: data.medias
        };
      });
    },
    /* 表单提交 */
    handleSubmit  () {
      this.form.validateFields((err, values) => {
        if (err) { return false; }
        this._put({
          url: `/householder/edit/${this.routeQuery}`,
          params: {
            ...values
          }
        }).then((res) => {
          this.$store.commit('setOptData', true);
          this.$message.success('删除成功');
        });
      });
    }
  }
};
</script>

<style lang="scss">
  @import "../../../style/variable";
  /** start 动态详情 */
  .dynamic {
    .dyna-hd {
      display: flex;
      justify-content: space-between;
      .user {
        display: flex;
        .avatar {
          margin-right: 10px;
          width: 60px;
          height: 60px;
          overflow: hidden;
          border-radius: 4px;
          border: 1px solid $gray_1;
          img {
            width: 60px;
            height: 60px;
          }
        }
        .value {
          display: flex;
          flex-direction: column;
          .column {
            margin-top: 16px;
          }
          .nick {
            margin-right: 60px;
          }
        }
      }
    }

    .dyna-content {
      width: 76%;
      margin-top: 14px;
      .descrip {
        margin-bottom: 10px;
        color: #333;
      }
      .media-box {
        display: flex;
        flex-wrap: wrap;
        flex: none;
        /** media容器 */
        .video-box,
        .img-box {
          position: relative;
          padding: 3px;
          max-width: 25%;
          .mask {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 10;
            cursor: pointer;
          }
          img,
          video {
            width: 100%;
            height: auto;
            border: 1px solid $gray_1;
            box-shadow: 0 2px 7px 0 $gray_1;
            border-radius: 2px;
          }
          .flag {
            position: absolute;
            top: 3px;
            right: 3px;
            padding: 2px 6px;
            font-size: 12px;
            color: #eee;
            background-color: rgba(255, 0, 0, 1);
          }
          .delete {
            position: absolute;
            top: -1px;
            right: -1px;
            z-index: 20;
            cursor: pointer;
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background-color: #fff;
            .anticon {
              color: rgb(255, 0, 0);
              font-size: 18px;
            }
          }
        }
      }
    }

    .comment {
      margin-bottom: 50px;
      padding-bottom: 30px;
      border-bottom: 1px solid $gray_1;
      .comment-hd {
        display: flex;
        justify-content: space-between;
        .user {
          display: flex;
        }
        .avatar {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
          border: 1px solid $gray_1;
          img {
            width: 42px;
            height: auto;
          }
        }
        .name {
          color: #333;
        }
      }

      .comment-content {
        margin-left: 70px;
        .num {
          margin: 16px 0 10px 0;
          line-height: 1;
          color: #000;
          font-size: 13px;
          font-weight: bold;
        }
        .list {
          padding: 6px 80px 6px 0;
          display: flex;
          margin-top: 10px;
          font-size: 13px;
          .time {
            margin-right: 5px;
            min-width: 150px;
          }
          .nick-box {
            white-space: nowrap;
          }
          .nick {
            color: #0099FF;
          }
          .feed {
            margin-left: 5px;
            min-width: 300px;
            max-width: 700px;
          }
          .ant-btn-sm {
            margin-left: 10px;
          }
        }
        .more {
          margin-top: 20px;
          cursor: pointer;
        }
      }
    }
  }
  /** end 动态详情 */
</style>
